import { AuthPage, AuthTitle } from "./authForms";

import ChangePasswordForm from "./ChangePasswordForm";
import Typography from "@material-ui/core/Typography";
import { constrained } from "./layouts";
import { useUser } from "../hooks/user";

// Full-screen forced prompt shown to newly provisioned admins whose temp
// password must be changed before they can use the app (INF-231).
const ForcedPrompt = constrained("sm")(function ForcedPrompt({ onSuccess }) {
  return (
    <AuthPage>
      <AuthTitle>Change your password</AuthTitle>
      <Typography align="center" color="textSecondary">
        You must set a new password before continuing.
      </Typography>
      <ChangePasswordForm
        onSuccess={onSuccess}
        submitLabel="Set new password"
      />
    </AuthPage>
  );
});

// Blocks all normal navigation while the authenticated admin's
// `passwordChangeRequired` flag is set. The flag is delivered (camelized by
// the shared axios instance) on the current-user response; a successful
// change clears it server-side, so we flip it in context to release the gate.
export default function ForcedPasswordChangeGate({ children }) {
  const { user, userAuthed, setUser } = useUser();

  if (userAuthed && user.passwordChangeRequired)
    return (
      <ForcedPrompt
        onSuccess={() => setUser({ ...user, passwordChangeRequired: false })}
      />
    );

  return children;
}
